/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubtitleEvent
 */
export interface SubtitleEvent {
    /**
     * 
     * @type {number}
     * @memberof SubtitleEvent
     */
    start: number;
    /**
     * 
     * @type {number}
     * @memberof SubtitleEvent
     */
    end: number;
    /**
     * 
     * @type {string}
     * @memberof SubtitleEvent
     */
    text: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubtitleEvent
     */
    marked?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubtitleEvent
     */
    layer?: number;
    /**
     * 
     * @type {string}
     * @memberof SubtitleEvent
     */
    style?: string;
    /**
     * 
     * @type {string}
     * @memberof SubtitleEvent
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof SubtitleEvent
     */
    marginl?: number;
    /**
     * 
     * @type {number}
     * @memberof SubtitleEvent
     */
    marginr?: number;
    /**
     * 
     * @type {number}
     * @memberof SubtitleEvent
     */
    marginv?: number;
    /**
     * 
     * @type {string}
     * @memberof SubtitleEvent
     */
    effect?: string;
    /**
     * 
     * @type {string}
     * @memberof SubtitleEvent
     */
    type?: string;
}

export function SubtitleEventFromJSON(json: any): SubtitleEvent {
    return SubtitleEventFromJSONTyped(json, false);
}

export function SubtitleEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubtitleEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'start': json['start'],
        'end': json['end'],
        'text': json['text'],
        'marked': !exists(json, 'marked') ? undefined : json['marked'],
        'layer': !exists(json, 'layer') ? undefined : json['layer'],
        'style': !exists(json, 'style') ? undefined : json['style'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'marginl': !exists(json, 'marginl') ? undefined : json['marginl'],
        'marginr': !exists(json, 'marginr') ? undefined : json['marginr'],
        'marginv': !exists(json, 'marginv') ? undefined : json['marginv'],
        'effect': !exists(json, 'effect') ? undefined : json['effect'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function SubtitleEventToJSON(value?: SubtitleEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'start': value.start,
        'end': value.end,
        'text': value.text,
        'marked': value.marked,
        'layer': value.layer,
        'style': value.style,
        'name': value.name,
        'marginl': value.marginl,
        'marginr': value.marginr,
        'marginv': value.marginv,
        'effect': value.effect,
        'type': value.type,
    };
}


